import { forwardRef, InputHTMLAttributes } from 'react';
import FormError from '../FormError';
import styles from './style.module.scss';

type InputProps = InputHTMLAttributes<HTMLInputElement> & {
  label?: string;
  labelClassName?: string;
  isRequired?: boolean;
  icon?: React.ReactNode;
  mainClassName?: string;
  error?: string;
};

const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      className,
      type = 'text',
      label,
      labelClassName,
      id,
      icon,
      isRequired,
      mainClassName,
      error,
      ...props
    },
    ref,
  ) => {
    return (
      <div className={`${styles.inputContainer} ${mainClassName}`}>
        {!!label && (
          <label htmlFor={id} className={`${styles.label} ${labelClassName}`}>
            {label} {icon && icon}{' '}
            {isRequired && <span className={styles.required}>*</span>}
          </label>
        )}
        <input
          type={type}
          id={id}
          className={`${styles.input} ${className}`}
          ref={ref}
          {...props}
        />
        {error && <FormError message={error} />}
      </div>
    );
  },
);

export default Input;
